import { useEffect, useRef } from 'react';

// Runs `onReset` whenever `key` changes, but never on the initial mount. Pair it
// with useTabNavResetKey so a screen clears transient view state (e.g. Leads
// filters, FLOSEAI-534) when the user re-enters it from another section, while
// leaving that state intact on a detail round-trip (router.back never pulses).
export function useResetOnKeyChange(key: number, onReset: () => void): void {
  const previousKeyRef = useRef(key);

  useEffect(() => {
    if (previousKeyRef.current === key) return;
    previousKeyRef.current = key;
    onReset();
  }, [key, onReset]);
}
